import MuiListItemButton, {
  type ListItemButtonProps as MuiListItemButtonProps,
} from '@mui/material/ListItemButton';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import classNames from 'classnames';
import React from 'react';

import type { Routes } from '../../../router';

import RouterLink from '../../RouterLink';
import './ListItemButton.scss';

export interface ListItemButtonProps extends MuiListItemButtonProps {
  /**
   * If provided, it will appen red error color to button
   */
  destructive?: boolean;
  to?: '/' | Routes;
}
const ListItemButton = React.forwardRef(
  (props: ListItemButtonProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const otherProps = omit(props, 'children', 'destructive');

    return (
      <MuiListItemButton
        {...otherProps}
        className={classNames(
          'Mfw-ListItemButton',
          {
            'Mfw-ListItemButton--destructive': props.destructive,
          },
          props.className,
        )}
        ref={ref}
        {...(props.to ? { to: props.to } : {})}
        {...(props.to ? { LinkComponent: RouterLink } : {})}
      >
        {props.children}
      </MuiListItemButton>
    );
  },
);

ListItemButton.displayName = 'ListItemButton';

export default React.memo(ListItemButton, (prevProps, nextProps) => {
  const withoutPrevPropsChildren = omit(prevProps, 'children');
  const withoutNextPropsChildren = omit(nextProps, 'children');
  return (
    prevProps.children === nextProps.children &&
    isEqual(withoutPrevPropsChildren, withoutNextPropsChildren)
  );
});
